<template>
  <div class="d-inline-flex">
    <v-tooltip bottom :disabled="configured">
      <template v-slot:activator="{ on, attrs }">
        <div v-bind="attrs" v-on="on">
          <v-btn
            small
            color="green darken-1"
            dark
            depressed
            :loading="loading"
            :disabled="disabled || !configured"
            @click="launch"
          >
            Conectar
            <v-icon right small>mdi-whatsapp</v-icon>
          </v-btn>
        </div>
      </template>
      <span>Configure VUE_APP_META_APP_ID e VUE_APP_META_CONFIG_ID</span>
    </v-tooltip>

    <v-snackbar v-model="snackbar" :color="snackColor" timeout="5000">
      {{ snackText }}
    </v-snackbar>
  </div>
</template>

<script>
import MESSAGER from "@/services/admin/messager.js";

const APP_ID = process.env.VUE_APP_META_APP_ID;
const CONFIG_ID = process.env.VUE_APP_META_CONFIG_ID;
const GRAPH_VERSION = process.env.VUE_APP_META_GRAPH_VERSION || "v21.0";

export default {
  name: "MetaSignupButton",
  props: {
    disabled: { type: Boolean, default: false },
    platformId: { type: String, default: null },
  },
  data: () => ({
    loading: false,
    sdkReady: false,
    sessionWabaId: null,
    snackbar: false,
    snackText: "",
    snackColor: "success",
  }),
  computed: {
    configured() {
      return !!APP_ID && !!CONFIG_ID;
    },
  },
  methods: {
    notify(text, color = "success") {
      this.snackText = text;
      this.snackColor = color;
      this.snackbar = true;
    },
    loadSdk() {
      return new Promise((resolve) => {
        if (window.FB) {
          this.sdkReady = true;
          return resolve();
        }
        window.fbAsyncInit = () => {
          window.FB.init({
            appId: APP_ID,
            autoLogAppEvents: true,
            xfbml: true,
            version: GRAPH_VERSION,
          });
          this.sdkReady = true;
          resolve();
        };
        if (!document.getElementById("facebook-jssdk")) {
          const s = document.createElement("script");
          s.id = "facebook-jssdk";
          s.src = "https://connect.facebook.net/en_US/sdk.js";
          s.async = true;
          s.defer = true;
          document.body.appendChild(s);
        }
      });
    },
    // Captura sessionInfo do Embedded Signup (waba_id/phone_number_id).
    onMessage(event) {
      if (!String(event.origin || "").endsWith("facebook.com")) return;
      try {
        const data =
          typeof event.data === "string" ? JSON.parse(event.data) : event.data;
        if (data.type === "WA_EMBEDDED_SIGNUP" && data.data) {
          this.sessionWabaId = data.data.waba_id || null;
        }
      } catch (e) {
        // payload nao-JSON; ignorar
      }
    },
    async launch() {
      if (!this.configured) return;
      try {
        this.loading = true;
        await this.loadSdk();

        const code = await new Promise((resolve, reject) => {
          window.FB.login(
            (response) => {
              const c = response?.authResponse?.code;
              if (c) resolve(c);
              else reject(new Error("Login do WhatsApp cancelado"));
            },
            {
              config_id: CONFIG_ID,
              response_type: "code",
              override_default_response_type: true,
              extras: { setup: {}, sessionInfoVersion: "3" },
            }
          );
        });

        const result = await MESSAGER.meta.embeddedSignup({
          code,
          wabaId: this.sessionWabaId || undefined,
          platformId: this.platformId || undefined,
        });

        const count = result.accounts?.length || 0;
        this.notify(
          count
            ? `${count} número(s) conectado(s) com sucesso`
            : "Conexão concluída",
          "success"
        );
        this.$emit("connected", result.accounts || []);
      } catch (error) {
        this.notify(error.message || "Falha ao conectar com a Meta", "error");
      } finally {
        this.loading = false;
        this.sessionWabaId = null;
      }
    },
  },
  mounted() {
    window.addEventListener("message", this.onMessage);
  },
  beforeDestroy() {
    window.removeEventListener("message", this.onMessage);
  },
};
</script>
